import React, { useState } from "react";
import { useAppConfig } from "../../Path/AppDashboard";
import AddService from "./AddService";
import { useTranslation } from "react-i18next";
const ServiceForm = ({ success, handleSucess }) => {
    const { appConfig, setAppConfig } = useAppConfig();
    const [openAddService, setOpenAddService] = useState(false);
    const {t} = useTranslation();
    return (
        <div className="mt-6">
            <button
                onClick={() => setOpenAddService(true)}
                className="text-sm text-primary hover:underline mt-2 bg-blue-600 py-2 px-4 rounded font-semibold text-white"
            >
                {t("addServiceLabel")}
            </button>
            {openAddService && <AddService cityId={appConfig?.cityId} handleSucess={handleSucess} close={() => setOpenAddService(false)} />}
        </div>
    );
}

export default ServiceForm;